var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Testimonials"}}),_c('ContentRow',[_c('ContentContainer',[_c('TestimonialList',{attrs:{"filter":_vm.filter}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }